import { render, staticRenderFns } from "./Loading.vue?vue&type=template&id=90d36c36&scoped=true&"
var script = {}
import style0 from "./Loading.vue?vue&type=style&index=0&id=90d36c36&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90d36c36",
  null
  
)

export default component.exports